import * as helper from './../../../Assets/Js/helper';

export function ChatButtons() {
	const links = helper.$('.model-chat-header-nav a');

	const privateChat = document.querySelector('.model-chat-privat');
	const modelChat = document.querySelector('.model-chat-content');
	const modelChatInput = document.querySelector('.model-chat-input');

	function clearActive() {
		for (const link of links) {
			helper.removeClass(link, 'active');
		}
	}

	for (const link of links) {
		helper.addClickListener(link, (e: MouseEvent) => {
			e.preventDefault();
			clearActive();
			helper.addClass(link, 'active');

			if (link === links[0]) {
				helper.addClass(privateChat, 'd-none');
				helper.removeClass(modelChat, 'd-none');
				if (!helper.hasClass(modelChat, 'blur')) {
					helper.removeClass(modelChatInput, 'd-none');
				}
			} else {
				helper.removeClass(privateChat, 'd-none');
				helper.addClass(modelChat, 'd-none');
				helper.addClass(modelChatInput, 'd-none');
			}
		})
	}
}
